import { Settings } from 'luxon';
import {
  AppRootElementBlueprint,
  createFrontendModule,
} from '@backstage/frontend-plugin-api';
import { useByxT } from '../shared/translations';

/**
 * Times in the portal language (Q-31, AC-32): the stock components
 * (Notificações, catalog cards, the scaffolder) format dates and relative
 * times through luxon's default locale, which is the browser's unless set.
 * This sets it from the app's messages (`time.dateLocale`) and follows a
 * language change, since a new language re-renders it with its own
 * messages.
 *
 * Set while rendering, not in an effect: the app root renders its extra
 * elements before the routes, so the first time a stock component formats
 * already reads in the portal language. The assignment is idempotent.
 */
export function PortalTimeLocale() {
  const { t } = useByxT();
  const locale = t('time.dateLocale');
  if (Settings.defaultLocale !== locale) {
    Settings.defaultLocale = locale;
  }
  return null;
}

export const portalTimeLocale = AppRootElementBlueprint.make({
  name: 'byx-time-locale',
  params: { element: <PortalTimeLocale /> },
});

/** App root elements are only accepted from the app plugin itself. */
export const localeModule = createFrontendModule({
  pluginId: 'app',
  extensions: [portalTimeLocale],
});
